<template>
<div class="test-question-answer-form">
    <div class="test-question-text" v-html="question.text"></div>
    <div class="test-question-answer-container">
        <component
            :is="answerComponent"
            :options="question.answers"
            :trans="trans"
            v-model="answer"
        />
    </div>
</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import TEST_QUESTION_TYPES from "../../../../const/test-question-types";
import TestQuestionSingleChoiceAnswer from "./answers/TestQuestionSingleChoiceAnswer";
import TestQuestionMultipleChoiceAnswer from "./answers/TestQuestionMultipleChoiceAnswer";
import TestQuestionNumberInputAnswer from "./answers/TestQuestionNumberInputAnswer";
import TestQuestionTextInputAnswer from "./answers/TestQuestionTextInputAnswer";

const QUESTION_TYPE_ANSWER_COMPONENT_MAP = {
    [TEST_QUESTION_TYPES.SINGLE_CHOICE]: TestQuestionSingleChoiceAnswer,
    [TEST_QUESTION_TYPES.MULTIPLE_CHOICE]: TestQuestionMultipleChoiceAnswer,
    [TEST_QUESTION_TYPES.NUMBER_INPUT]: TestQuestionNumberInputAnswer,
    [TEST_QUESTION_TYPES.TEXT_INPUT]: TestQuestionTextInputAnswer,
};

export default {
    name: "TestQuestionAnswerForm",
    props: {
        question: Object,
    },
    computed: {
        ...mapGetters('tests', [
            'trans',
            'testTaker',
        ]),
        answerComponent() {
            return QUESTION_TYPE_ANSWER_COMPONENT_MAP[this.question.type];
        },

        answer: {
            get() {
                return this.testTaker.question.userAnswer;
            },
            set(value) {
                this.setQuestionUserAnswer(value);
            }
        }
    },
    methods: {
        ...mapActions('tests', [
            'setQuestionUserAnswer',
        ]),
    }
}
</script>

<style lang="scss" scoped>
@import '../../../../../sass/variables';

.test-question-answer-container {
    background: #FAFAFA;
    border: 1px solid $tests-light-grey;
    border-radius: 6px;
    width: 100%;
}

.test-question-text {
    font-size: 1rem;
    margin-bottom: 25px;
}
</style>